import React, { useMemo } from "react";

// Abstract "scenario mapping" animation: dots being connected. No labels, no
// company data. Transparent background, coloured with aqua, teal and a pink
// accent. The viewBox is generously padded so nodes, glows and drift motion
// never clip against the container edges.
export const ScenarioMap = ({ height = 360, active = true }) => {
  const W = 480;
  const H = 360;

  const nodes = useMemo(
    () => [
      { x: 240, y: 180, r: 30, hub: true },
      { x: 96, y: 82, r: 12, c: "#2FE1EC", d: "drift-a", delay: 0 },
      { x: 380, y: 92, r: 11, c: "#3FC1C9", d: "drift-b", delay: 0.3 },
      { x: 78, y: 248, r: 11, c: "#FC5185", d: "drift-b", delay: 0.6 },
      { x: 396, y: 256, r: 14, c: "#2FE1EC", d: "drift-a", delay: 0.15 },
      { x: 208, y: 58, r: 10, c: "#3FC1C9", d: "drift-b", delay: 0.45 },
      { x: 288, y: 302, r: 12, c: "#FC5185", d: "drift-a", delay: 0.75 },
      { x: 432, y: 180, r: 9, c: "#2FE1EC", d: "drift-b", delay: 0.25 },
      { x: 56, y: 166, r: 10, c: "#3FC1C9", d: "drift-a", delay: 0.4 },
      { x: 150, y: 314, r: 8, c: "#2FE1EC", d: "drift-b", delay: 0.9 },
      { x: 336, y: 46, r: 8, c: "#FC5185", d: "drift-a", delay: 0.55 },
    ],
    []
  );

  const edges = [
    [0, 1, "#2FE1EC"], [0, 2, "#3FC1C9"], [0, 3, "#FC5185"], [0, 4, "#2FE1EC"],
    [0, 5, "#3FC1C9"], [0, 6, "#FC5185"], [0, 7, "#2FE1EC"], [0, 8, "#3FC1C9"],
    [0, 9, "#2FE1EC"], [0, 10, "#FC5185"],
    [1, 5, "#2FE1EC"], [2, 7, "#3FC1C9"], [4, 6, "#FC5185"], [3, 8, "#3FC1C9"],
    [5, 10, "#FC5185"], [6, 9, "#2FE1EC"],
  ];

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      width="100%"
      height={height}
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="Scenario mapping animation"
      data-testid="scenario-map"
      style={{ background: "transparent", overflow: "visible", display: "block" }}
    >
      <defs>
        <radialGradient id="hubGlowA" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#2FE1EC" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#2FE1EC" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="hubGlowP" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#FC5185" stopOpacity="0.2" />
          <stop offset="100%" stopColor="#FC5185" stopOpacity="0" />
        </radialGradient>
      </defs>

      <circle cx={nodes[0].x} cy={nodes[0].y} r="130" fill="url(#hubGlowA)" />
      <circle cx={nodes[4].x} cy={nodes[4].y} r="88" fill="url(#hubGlowP)" />

      {edges.map(([a, b, col]) => (
        <line key={`e-${a}-${b}`} x1={nodes[a].x} y1={nodes[a].y} x2={nodes[b].x} y2={nodes[b].y} stroke={col} strokeWidth="1.6" opacity="0.55" className={active ? "sweep-line" : ""} />
      ))}

      {nodes.map((n, i) =>
        n.hub ? null : (
          <g key={`n-${n.x}-${n.y}`} className={active ? n.d : ""} style={{ transformOrigin: `${n.x}px ${n.y}px`, animationDelay: `${n.delay}s` }}>
            <circle cx={n.x} cy={n.y} r={n.r + 7} fill={n.c} opacity="0.16" className={active ? "node-pulse" : ""} style={{ transformOrigin: `${n.x}px ${n.y}px` }} />
            <circle cx={n.x} cy={n.y} r={n.r} fill={n.c} />
          </g>
        )
      )}

      <circle cx={nodes[0].x} cy={nodes[0].y} r={nodes[0].r} fill="#364F6B" />
      <circle cx={nodes[0].x} cy={nodes[0].y} r={nodes[0].r} fill="none" stroke="#2FE1EC" strokeWidth="3" className={active ? "node-pulse" : ""} style={{ transformOrigin: `${nodes[0].x}px ${nodes[0].y}px` }} />
      <circle cx={nodes[0].x} cy={nodes[0].y} r="7" fill="#FC5185" />
    </svg>
  );
};
